import React from 'react';
import {Helmet} from 'react-helmet';

import {title, meta} from 'lib/head';
import {ERROR_TYPES} from 'client/constants';

import ErrorPage from './ErrorPage.react';

/**
 * The router's 404: the requested URL matches no route, so it exists only as a dead end.
 *
 * The app is a client-rendered SPA and always answers HTTP 200, so these tags are the only thing
 * that tells a crawler the URL is dead. They belong here rather than in `ErrorPage`, which also
 * renders inline on URLs that do exist.
 */
export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        {title('Page not found (404) | Albert')}
        {meta.description(`This page doesn't exist or has moved.`)}
        <meta name='robots' content='noindex, nofollow' />
      </Helmet>
      <ErrorPage errorCode={ERROR_TYPES.NOT_FOUND} />
    </>
  );
}
